import { render, staticRenderFns } from "./utiles-detalles-publicacion.vue?vue&type=template&id=f0bf8dd4&scoped=true&"
import script from "./utiles-detalles-publicacion.vue?vue&type=script&lang=ts&"
export * from "./utiles-detalles-publicacion.vue?vue&type=script&lang=ts&"
import style0 from "./utiles-detalles-publicacion.vue?vue&type=style&index=0&id=f0bf8dd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bf8dd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VCarousel,VCarouselItem,VChip,VCol,VIcon,VImg,VRow,VSheet,VTooltip})
